// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Tw3u","selected":"Chip_selected__2LF4Q"};